import { ContentRender } from '../renderer/content-renderer';
import { createElement, isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import { getEditValue } from '../base/util';
import { IFRAME_EDITOR_STYLES, IFRAME_EDITOR_LIGHT_THEME_STYLES, IFRAME_EDITOR_DARK_THEME_STYLES } from '../../common/editor-styles';
import { CLS_RTE_IFRAME_CONTENT } from '../base';
/**
 * Content module is used to render Rich Text Editor content
 *
 * @hidden
 * @deprecated
 */
export class IframeContentRender extends ContentRender {
    constructor() {
        super(...arguments);
        this.styles = this.getEditorStyles();
        this.IFRAMEHEADER = `
    <!DOCTYPE html> 
    <html>
         <head>
            <meta charset='utf-8' /> 
            <style>` +
            this.styles + `
            </style>
        </head>
    `;
    }
    /* Gets editor styles with theme-specific styling */
    getEditorStyles() {
        // Get base editor styles
        const baseStyles = IFRAME_EDITOR_STYLES.replace(/[\n\t]/g, '');
        // Detect theme
        const themeStyle = window.getComputedStyle(this.parent.element.querySelector('.e-rte-container'));
        const isDarkTheme = themeStyle.content.includes('dark-theme');
        // Select theme styles based on current theme
        const themeStyles = (isDarkTheme ?
            IFRAME_EDITOR_DARK_THEME_STYLES :
            IFRAME_EDITOR_LIGHT_THEME_STYLES).replace(/[\n\t]/g, '');
        // Return combined styles
        return baseStyles + themeStyles;
    }
    renderPanel() {
        const rteObj = this.parent;
        const rteContent = getEditValue(rteObj.value, rteObj);
        const iFrameBodyContent = '<body contenteditable="true" aria-label="Rich Text Editor" lang="' +
            this.parent.locale.slice(0, 2) +
            '" dir="' + (this.parent.enableRtl ? 'rtl' : 'ltr') +
            '">' + rteContent + '</body></html>';
        let iFrameContent = this.IFRAMEHEADER + iFrameBodyContent;
        const iframe = this.parent.createElement('iframe', {
            id: this.parent.getID() + '_rte-view',
            className: 'e-rte-content',
            attrs: { 'srcdoc': iFrameContent }
        });
        iframe.setAttribute('role', 'none');
        this.setPanel(iframe);
        if (!isNOU(this.parent.iframeSettings.sandbox)) {
            let sandboxValues = this.parent.iframeSettings.sandbox
                .map((element) => element.toLocaleLowerCase().trim())
                .join(' ');
            if (!sandboxValues.includes('allow-same-origin')) {
                sandboxValues += ' allow-same-origin';
            }
            iframe.setAttribute('sandbox', sandboxValues.trim());
        }
        const iframeWrapper = createElement('div', { className: CLS_RTE_IFRAME_CONTENT });
        rteObj.rootContainer.appendChild(iframeWrapper);
        iframeWrapper.appendChild(iframe);
        iframe.contentDocument.body.setAttribute('aria-owns', this.parent.getID());
        iframe.contentDocument.open();
        iFrameContent = this.setThemeColor(iFrameContent, { color: '#333' });
        iframe.contentDocument.write(iFrameContent);
        iframe.contentDocument.close();
        const body = iframe.contentDocument.body;
        body.className = 'e-content';
        if (this.parent.height === 'auto') {
            body.style.overflowY = 'hidden';
        }
        if (!isNOU(this.parent.fontFamily.default)) {
            body.style.fontFamily = this.parent.fontFamily.default;
        }
        if (!isNOU(this.parent.fontSize.default)) {
            body.style.fontSize = this.parent.fontSize.default;
        }
        body.id = this.parent.getID() + '_rte-edit-view';
        if (rteObj.enableRtl) {
            this.contentPanel.contentDocument.body.classList.add('e-rtl');
        }
        if (!isNOU(iframe.contentDocument.head) && this.parent.iframeSettings.metaTags.length > 0) {
            const head = iframe.contentDocument.head;
            const metaData = this.parent.iframeSettings.metaTags;
            metaData.forEach((tag) => {
                const meta = document.createElement('meta');
                for (const key in tag) {
                    if (!isNOU(tag[key])) {
                        meta.setAttribute((key === 'httpEquiv') ? 'http-equiv' : key, tag[key]);
                    }
                }
                head.appendChild(meta);
            });
        }
    }
    setThemeColor(content, styles) {
        const fontColor = getComputedStyle(this.parent.element, '.e-richtexteditor').getPropertyValue('color');
        return content.replace(styles.color, fontColor);
    }
    /**
     * Get the editable element of RichTextEditor
     *
     * @returns {Element} - specifies the element.
     * @hidden
     * @deprecated
     */
    getEditPanel() {
        let editNode;
        if (!isNOU(this.contentPanel.contentDocument)) {
            editNode = this.contentPanel.contentDocument.body;
        }
        else {
            editNode = this.parent.inputElement;
        }
        return editNode;
    }
    /**
     * Get the document of RichTextEditor
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getDocument() {
        return this.getEditPanel().ownerDocument;
    }
}
